import { useState } from "react";
import { Platform, Share } from "react-native";

import analytics from "../../analytics";
import SocialIconsModal from "../shared/SocialIconsModal";
import { t } from "@/localization";

// title: the event's title; the share subject adds "You're invited to watch".
export const useSharePress = (title, url) => {
  const [socialIconsVisible, setsocialIconsVisible] = useState(false);
  const shareSubject = t("You're invited to watch {title}", { title });

  const sharePress = async () => {
    // Analytics track
    analytics.track("Share Link", {
      url,
      title: shareSubject,
    });

    if (Platform.OS === "web") {
      if (navigator.share) {
        try {
          await navigator.share({
            title: shareSubject,
            url: url,
          });
        } catch (error) {
          console.error("Error sharing:", error);
        }
      } else {
        // Show modal instead of copying to clipboard
        setsocialIconsVisible(true);
      }
    } else {
      try {
        if (Platform.OS === "ios") {
          await Share.share(
            {
              title: url,
              url: url,
            },
            {
              subject: shareSubject,
              excludedActivityTypes: [
                "com.apple.mobilenotes.SharingExtension",
                "com.apple.reminders.RemindersEditorExtension",
                "UIActivityTypeAddToReadingList",
              ],
            }
          );
        } else {
          // Android
          await Share.share(
            {
              title: shareSubject,
              message: url,
            },
            {
              dialogTitle: t("Share your event link"),
            }
          );
        }
      } catch (error) {
        console.error("Error sharing:", error);
      }
    }
  };

  const ShareModal = () =>
    Platform.OS === "web" ? (
      <SocialIconsModal
        visible={socialIconsVisible}
        url={url}
        title={shareSubject}
        text={shareSubject}
        onRequestClose={() => {
          setsocialIconsVisible(false);
        }}
      />
    ) : null;

  return { sharePress, ShareModal };
};

export default useSharePress;
